import { isProviderRateOrQuotaError } from "./publicProviderCopy";

interface RemoteUsageLimitEvent {
  readonly sequence: number | null;
  readonly occurredAt: string;
  readonly kind: string;
  readonly turnId: string | null;
  readonly text: string | null;
}

interface RemoteUsageLimitReplica {
  readonly thread: { readonly status: string };
  readonly events: readonly RemoteUsageLimitEvent[];
}

function compareEvents(left: RemoteUsageLimitEvent, right: RemoteUsageLimitEvent): number {
  if (left.sequence !== null && right.sequence !== null && left.sequence !== right.sequence) {
    return left.sequence - right.sequence;
  }
  return left.occurredAt.localeCompare(right.occurredAt);
}

export function currentRemoteUsageLimitError(
  replica: RemoteUsageLimitReplica | null,
): string | null {
  if (replica?.thread.status !== "failed") return null;
  const events = replica.events.toSorted(compareEvents);
  const latestUserMessage = events.findLast((event) => event.kind === "user_message");
  const latestError = events.findLast((event) => event.kind === "error_summary");
  if (!latestError?.text || !isProviderRateOrQuotaError(latestError.text)) return null;
  if (
    latestUserMessage?.turnId &&
    latestError.turnId &&
    latestUserMessage.turnId !== latestError.turnId
  ) {
    return null;
  }
  if (latestUserMessage && compareEvents(latestError, latestUserMessage) < 0) return null;
  return latestError.text;
}
